import {isArray} from "rxjs/util/isArray";

export class TranscriptionSentence {
  start: number;
  end: number;
  text: string;
  timing: any[];

  static fromJson(json): TranscriptionSentence {
    if (!json){
      throw new Error("missing json");
    }

    const sentence = new TranscriptionSentence();

    sentence.start = json.start;
    sentence.end = json.end;
    sentence.text = json.text;
    sentence.timing = json.timing;

    return sentence;
  }

  static fromJsonArray(jsonArray: any[]): TranscriptionSentence[] {
    if (!jsonArray || !isArray(jsonArray)){
      throw new Error("wrong jason");
    }

    const sentences = [];

    jsonArray.forEach(item => {
      sentences.push(TranscriptionSentence.fromJson(item));
    });

    return sentences;
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/shared/TranscriptionSentence.ts